// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CallAccessForm__container-d1fd53 {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: auto;
}

.CallAccessForm__switch-e772c8 {
  padding: 12px 24px;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/popups/Permissions/CallPermissionsPopup/components/CallAccessForm/CallAccessForm.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,OAAA;EACA,cAAA;AACF;;AAEA;EACE,kBAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  overflow: auto;\n}\n\n.switch {\n  padding: 12px 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CallAccessForm__container-d1fd53`,
	"switch": `CallAccessForm__switch-e772c8`
};
module.exports = ___CSS_LOADER_EXPORT___;
